import * as THREE from 'three'
import Experience from "../Experience";
import Tableau1 from './Tableau1';
import Tableau2 from './Tableau2';
import Tableau3 from './Tableau3';
import Stats from 'stats.js'
import Soul from './assets/Soul';
import anim from '../Utils/Anim';
import Html from './Html';
import Tableau4 from './Tableau4';
import Tableau5 from './Tableau5';
import Tableau6 from './Tableau6';

export default class World {

    constructor() {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.ressources = this.experience.ressources
        this.time = this.experience.time
        this.router = this.experience.router
        // 
        this.currentTableau = null;
        this.tableaux = {};
        // 
        this.debugObject = {
            // targetSpeed: 0
            targetSpeed: 0.7
        }

        this.camera = {
            position: new THREE.Vector3(0, 0, 0),
            target: new THREE.Vector3(0, 0, 0),
        }
        this.delayedPath = this.router.path
        this.targetPos = new THREE.Vector3(0, -1.25, 0.3)
        this.targetSpeed = this.debugObject.targetSpeed
        this.activeTimeouts = []





        this.setMainSoul()
        this.router.on('routing', () => {
            this.lastUpdateTime = this.time.elapsed

            const path = this.router.path;

            this.handleRouting(path);

            this.prevRoute = this.router.prevRoute



            setTimeout(() => {
                this.delayedPath = this.router.path
            }, 1000);


        });


        // 
        this.html = new Html()

        this.experience.debug.active ? this.setStats() : null
        this.experience.debug.active ? this.setDebug() : null
        this.update()
        // this.testRenderer()
    }
    // utils
    testRenderer() {
        function countMaterials(scene) {
            const materials = new Set();

            scene.traverse((child) => {
                if (child.isMesh) {
                    if (Array.isArray(child.material)) {
                        child.material.forEach((mat) => materials.add(mat));
                    } else {
                        materials.add(child.material);
                    }
                }
            });

            return materials.size;
        }
        console.log(this.experience.renderer.instance.info);
        console.log(countMaterials(this.scene))
        setTimeout(() => {
            this.tableau2.destroy()
            setTimeout(() => {
                console.log(this.experience.renderer.instance.info);
                console.log(countMaterials(this.scene))


            }, 3000)

        }, 3000)

    }

    setStats() {
        this.stats = new Stats()
        this.stats.showPanel(0);
        document.body.appendChild(this.stats.dom);
    }

    setDebug() {
        const ui = this.experience.debug.ui
        ui.add(this.debugObject, 'targetSpeed').min(0).max(5).step(0.001).onChange((value) => { this.targetSpeed = value })
    }
    animateClearColor(from, to, duration = 1, target = this.experience.renderer.instance) {
        const renderer = this.experience.renderer.instance

        // Stocker une référence à l'animation actuelle
        if (this.clearColorTween) {
            this.clearColorTween.kill() // Stopper l'animation précédente
        }

        const fromColor = new THREE.Color(from)
        const toColor = new THREE.Color(to)

        const colorObj = {
            r: fromColor.r,
            g: fromColor.g,
            b: fromColor.b,
        }

        this.clearColorTween = anim.to(colorObj, {
            r: toColor.r,
            g: toColor.g,
            b: toColor.b,
            duration,
            onUpdate: () => {
                renderer.setClearColor(new THREE.Color(colorObj.r, colorObj.g, colorObj.b))
            },
            onComplete: () => {
                this.clearColorTween = null // Nettoyer la référence une fois terminé
                renderer.setClearColor(new THREE.Color(toColor.r, toColor.g, toColor.b))
            }
        })
    }


    // for the scene
    setMainSoul() {
        if (this.experience.debug.active) {
            const ui = this.experience.debug.ui
            this.soulFolder = ui.addFolder('main soul')
        }

        this.soul = new Soul({
            position: this.targetPos,
            debugFolder: this.soulFolder,
        })
        this.soul.mesh.scale.set(0.3, 0.3, 0.3)
        this.soul.material.uniforms.u_gotIdea.value = 1
        this.soulRandom = Math.random()


    }
    safeSetTimeout(callback, delay) {
        const id = setTimeout(callback, delay)
        this.activeTimeouts.push(id)
        return id
    }
    clearAllTimeouts() {
        this.activeTimeouts.forEach(clearTimeout)
        this.activeTimeouts = []
    }
    handleRouting(path) {
        // Clean current tableau if any
        if (this.currentTableau && this.currentTableau.destroy) {
            this.currentTableau.destroy();
            this.currentTableau = null;

        }


        // Lazy init tableau if not already created
        switch (path) {
            case '/chapitre1':
                this.experience.renderer.ssaaRenderPass.clearAlpha = 0.005
                if (this.router.prevRoute == '/chapitre6') {
                    // this.animateClearColor('#ffffff', '#010101', 0)

                }
                // timeout so the menu can close cool
                const blackScreen = document.querySelector('.blackScreen');
                // 1. Opacité à 1 sans transition
                blackScreen.style.transition = 'opacity 0.3s ease-in-out';
                blackScreen.style.opacity = '1';
                this.safeSetTimeout(() => {
                    this.experience.renderer.bloomPass.strength = 0.5
                    // 2. Forcer un reflow pour que le style soit bien appliqué avant la transition
                    blackScreen.getBoundingClientRect(); // 👈 correction ici : pas `.style.getBoudingClientRect()`
                    // 3. Ajouter la transition et passer à opacité 0
                    blackScreen.style.transition = 'opacity 1s ease-in-out';
                    blackScreen.style.opacity = '0';
                    // 
                    this.tableaux.tableau1 = null
                    this.tableaux.tableau1 = new Tableau1({
                        model: this.ressources.items.tableau1Model,
                        modelTexture: this.ressources.items.tableau1Texture,
                    });
                    this.currentTableau = this.tableaux.tableau1;
                    this.targetSpeed = 0
                    this.targetPos.x = 0
                    this.soul.mesh.visible = false

                }, 1000)
                break;
            case '/chapitre2':
                if (this.router.prevRoute == '/chapitre6') {
                    // this.animateClearColor('#ffffff', '#010101', 0)

                }

                this.shouldResetCamera = true
                this.soul.material.uniforms.u_appear.value = 1

                this.soul.material.uniforms.u_red.value = 0
                this.experience.renderer.ssaaRenderPass.clearAlpha = 0.005

                anim.to(this.experience.renderer.bloomPass, { strength: 0.23, duration: 1 })
                anim.to(this.soul.material.uniforms.u_gotIdea, { value: 1, duration: 1 })
                anim.to(this.soul.material.uniforms.u_powerShine, { value: 0.1, duration: 1 })
                anim.to(this.soul.material.uniforms.u_amplitude, { value: 0.5, duration: 1 })
                anim.to(this.soul.material.uniforms.u_flat, { value: 0, duration: 2, easing: 'power2.out' })
                this.safeSetTimeout(() => {

                    this.tableaux.tableau2 = null
                    this.tableaux.tableau2 = new Tableau2({
                        batiment: this.ressources.items.batiment,
                        targetPos: this.targetPos,
                    });
                    this.soul.mesh.visible = true
                    anim.to(this.soul.material.uniforms.u_flat, { value: 0, duration: 2, easing: 'power2.out' })
                    this.currentTableau = this.tableaux.tableau2;
                    // Stocker l'ID du setInterval
                    this.soulInterval = setInterval(() => {
                        this.soul.setEmotion(this.soulRandom < 0.5 ? 'sad' : 'round')
                        this.soulRandom = Math.random()
                    }, 3000 + (this.soulRandom * 1000));
                    this.targetSpeed = 0.7
                    anim.to(this.experience.renderer.darkMaterial, {
                        opacity: 1,
                        duration: 1,
                        onComplete: () => {
                            this.experience.renderer.darkMaterial.transparent = false
                        }
                    })

                }, 1000)
                break;

            case '/chapitre3':
                if (this.router.prevRoute == '/chapitre6') {
                    // this.animateClearColor('#ffffff', '#010101', 0)


                }

                this.tableaux.tableau3 = null
                this.tableaux.tableau3 = new Tableau3({
                    targetPos: this.targetPos,
                });
                this.currentTableau = this.tableaux.tableau3;
                this.soul.material.uniforms.u_appear.value = 1

                this.soul.material.uniforms.u_red.value = 0
                this.experience.renderer.ssaaRenderPass.clearAlpha = 0.005

                this.safeSetTimeout(() => {
                    if (this.tableaux.tableau3) {
                        this.soul.mesh.visible = true

                        this.targetSpeed = 0.2


                        anim.to(this.soul.material.uniforms.u_gotIdea, { value: 0, duration: 1 })
                        anim.to(this.soul.material.uniforms.u_powerShine, { value: 0.02, duration: 1 })
                        anim.to(this.soul.material.uniforms.u_flat, { value: 1, duration: 2, easing: 'power2.out' })
                        anim.to(this.experience.renderer.bloomPass, { strength: 0.1, duration: 1 })
                        anim.to(this.soul.material.uniforms.u_amplitude, { value: 0.5, duration: 1 })

                        if (this.soulInterval) {
                            clearInterval(this.soulInterval);
                            this.soulInterval = null;
                        }
                        this.soul.setEmotion('sad')
                    }
                }, 1000)

                break;
            case '/chapitre4':

                this.soul.mesh.visible = true
                this.experience.renderer.ssaaRenderPass.clearAlpha = 0.005


                if (this.router.prevRoute == '/chapitre5') {
                    this.soul.appear()

                }
                if (this.router.prevRoute == '/chapitre6') {
                    // this.animateClearColor('#ffffff', '#010101', 0)

                    anim.to(this.soul.material.uniforms.u_appear, { value: 1, duration: 1 })



                }

                this.targetSpeed = 0.1
                this.soul.material.uniforms.u_red.value = 0
                anim.to(this.experience.renderer.ssaaRenderPass, { clearAlpha: 0.005, duration: 1 })

                anim.to(this.soul.material.uniforms.u_gotIdea, { value: 1, duration: 1 })
                anim.to(this.soul.material.uniforms.u_powerShine, { value: 0.02, duration: 1 })
                anim.to(this.soul.material.uniforms.u_flat, { value: 1, duration: 2, easing: 'power2.out' })
                anim.to(this.experience.renderer.bloomPass, { strength: 0.3, duration: 2 })
                anim.to(this.soul.material.uniforms.u_amplitude, { value: 0.2, duration: 1 })


                if (this.soulInterval) {
                    clearInterval(this.soulInterval)
                }
                this.soul.setEmotion('sad')

                this.targetSpeed = 0
                this.tableaux.tableau4 = null
                this.tableaux.tableau4 = new Tableau4({
                    targetPos: this.targetPos,
                });
                this.currentTableau = this.tableaux.tableau4;

                break;
            case '/chapitre5':

                this.soul.mesh.visible = true

                this.soul.material.uniforms.u_appear.value = 1
                anim.to(this.soul.material.uniforms.u_appear, { value: 0, duration: 1 })

                this.targetSpeed = 0.1

                anim.to(this.soul.material.uniforms.u_red, { value: 0, duration: 1 })
                anim.to(this.soul.material.uniforms.u_gotIdea, { value: 1, duration: 1 })
                anim.to(this.soul.material.uniforms.u_flat, { value: 0, duration: 2, easing: 'power2.out' })
                anim.to(this.experience.renderer.bloomPass, { strength: 0.3, duration: 2 })
                anim.to(this.soul.material.uniforms.u_amplitude, { value: 0.2, duration: 1 })



                if (this.soulInterval) {
                    clearInterval(this.soulInterval)
                }
                this.soul.setEmotion('sad')
                if (this.router.prevRoute !== '/chapitre6') {
                    // this.animateClearColor('#010101', '#010101')
                    this.experience.renderer.ssaaRenderPass.clearAlpha = 0.005
                    this.soul.disapear()
                    this.safeSetTimeout(() => {
                        this.targetSpeed = 0
                        anim.to(this.soul.material.uniforms.u_powerShine, { value: 0, duration: 1 })



                        this.tableaux.tableau5 = null
                        this.tableaux.tableau5 = new Tableau5({
                            targetPos: this.targetPos,
                            from6: false,
                        });
                        this.currentTableau = this.tableaux.tableau5;
                    }, 1000)
                } else {
                    this.targetSpeed = 0
                    anim.to(this.soul.material.uniforms.u_powerShine, { value: 0, duration: 1 })
                    this.tableaux.tableau5 = null
                    this.tableaux.tableau5 = new Tableau5({
                        targetPos: this.targetPos,
                        from6: true,
                    });
                    this.currentTableau = this.tableaux.tableau5;
                    this.safeSetTimeout(() => {
                        anim.to(this.experience.renderer.ssaaRenderPass, { clearAlpha: 0.005, duration: 1 })

                        // this.animateClearColor('#ffffff', '#010101', 1)
                    }, 500)
                }


                break;
            case '/chapitre6':
                this.targetSpeed = 0.5
                if (this.router.prevRoute == '/chapitre5') {
                    this.safeSetTimeout(() => {
                        // this.animateClearColor('#010101', '#f9f9f9', 0.5)
                        anim.to(this.experience.renderer.ssaaRenderPass, { clearAlpha: 0.99, duration: 0.5 })


                    }, 1500)
                } else {
                    anim.to(this.experience.renderer.ssaaRenderPass, { clearAlpha: 1, duration: 0.5 })

                    // this.animateClearColor('#010101', '#f9f9f9', 0)

                }

                this.soul.mesh.visible = false
                this.soul.material.uniforms.u_appear.value = 0
                this.soul.material.uniforms.u_flat.value = 0.1
                this.soul.material.uniforms.u_red.value = 1

                this.safeSetTimeout(() => {

                    anim.to(this.soul.material.uniforms.u_appear, { value: 1, duration: 1 })
                    anim.to(this.experience.renderer.bloomPass, { strength: 0.1, duration: 2 })
                    anim.to(this.soul.material.uniforms.u_amplitude, { value: 0.2, duration: 1 })
                    this.tableaux.tableau6 = null
                    this.tableaux.tableau6 = new Tableau6({
                        targetPos: this.targetPos,
                    });


                }, 1000)
                if (this.soulInterval) {
                    clearInterval(this.soulInterval);
                    this.soulInterval = null;
                }
                this.soul.setEmotion('happy')
                break;
            default:

                console.warn(`Unknown route: ${path}`);
        }
    }
    resize() {
        if (this.tableaux.tableau4) {
            this.tableaux.tableau4.resize()
        }
        if (this.tableaux.tableau5) {
            this.tableaux.tableau5.resize()
        }
    }

    updateCamera() {


        // Utilise delayedPath uniquement si route ou prevRoute est '/chapitre1'
        const effectivePath = (this.router.path === '/chapitre1' || this.router.prevRoute === '/chapitre1')
            ? this.delayedPath
            : this.router.path;

        // ! le delayedPath créera un mouvement de caméra délayé dans le temps pour une trandition douce en ce qui concerne le chapitre 1
        // ! le path standard permet une adaptaion plus dynamique de la camera au routing

        switch (effectivePath) {
            case '/chapitre1':
                this.camera.target.set(0, 0, -3);
                this.camera.position.set(Math.cos(this.time.elapsed * 0.0001) * 0.5, Math.sin(this.time.elapsed * 0.0001) * 0.5 + 1, 4);
                this.experience.camera.instance.position.copy(this.camera.position);
                this.experience.camera.instance.lookAt(this.camera.target);

                break;

            case '/chapitre2':
                this.camera.position.set(
                    this.targetPos.x + 3 + Math.cos(this.time.elapsed * 0.0005),
                    Math.cos(this.time.elapsed * 0.0005) + 3,
                    7 - Math.cos(this.time.elapsed * 0.0005)
                )
                this.shouldResetCamera = true
                if (this.shouldResetCamera && this.router.prevRoute == '/chapitre1') {
                    this.camera.target.copy(new THREE.Vector3(this.targetPos.x + 3, -0.2, 1));
                    this.shouldResetCamera = false
                } else {
                    this.camera.target.lerp(new THREE.Vector3(this.targetPos.x + 3, -0.2, 1), 0.01);

                }
                this.camera.target.lerp(new THREE.Vector3(this.targetPos.x + 3, -0.2, 1), 0.01);
                this.experience.camera.instance.position.lerp(this.camera.position, 0.1);
                this.experience.camera.instance.lookAt(this.camera.target);
                break;

            case '/chapitre3':
                this.camera.position.set(
                    this.targetPos.x + 3 + Math.cos(this.time.elapsed * 0.0005),
                    Math.cos(this.time.elapsed * 0.0005) + 3,
                    7 - Math.sin(this.time.elapsed * 0.0005)
                );

                this.camera.target.lerp(new THREE.Vector3(this.targetPos.x + 0.5, this.targetPos.y - 0.8, this.targetPos.z), 0.01);
                this.experience.camera.instance.position.lerp(this.camera.position, 0.01);
                this.experience.camera.instance.lookAt(this.camera.target);
                break;
            case '/chapitre4':
                this.camera.position.set(
                    this.targetPos.x + 10,
                    0,
                    0.5
                );

                this.camera.target.lerp(new THREE.Vector3(this.targetPos.x, this.targetPos.y + 0.5, this.targetPos.z), 0.01);
                this.experience.camera.instance.position.lerp(this.camera.position, 0.01);
                this.experience.camera.instance.lookAt(this.camera.target);
                break;
            case '/chapitre5':
                this.camera.position.set(
                    this.targetPos.x + 10,
                    0,
                    0.5
                );

                this.camera.target.lerp(new THREE.Vector3(this.targetPos.x, this.targetPos.y + 0.5, this.targetPos.z), 0.01);
                this.experience.camera.instance.position.lerp(this.camera.position, 0.01);
                this.experience.camera.instance.lookAt(this.camera.target);
                break;
            case '/chapitre6':
                this.camera.position.set(
                    this.targetPos.x + 7,
                    0,
                    0.5
                );

                this.camera.target.lerp(new THREE.Vector3(this.targetPos.x, this.targetPos.y, this.targetPos.z), 0.01);
                this.experience.camera.instance.position.lerp(this.camera.position, 0.01);
                this.experience.camera.instance.lookAt(this.camera.target);
                break;


            default:
            // Aucun comportement défini
        }
    }


    update() {
        if (document.hasFocus()) {
            this.targetPos.x += this.time.delta * this.targetSpeed;
        }

        this.updateCamera()
        // 
        if (this.tableaux.tableau1) {
            this.tableaux.tableau1.update()

        }
        if (this.tableaux.tableau2) {
            this.tableaux.tableau2.update()

        }
        if (this.tableaux.tableau3) {
            this.tableaux.tableau3.update()

        }
        if (this.tableaux.tableau4) {
            this.tableaux.tableau4.update()
        }
        if (this.tableaux.tableau5) {
            this.tableaux.tableau5.update()
        }
        if (this.tableaux.tableau6) {
            this.tableaux.tableau6.update()
        }
        if (this.soul) {
            this.soul.position.copy(this.targetPos)

            this.soul.update()

        }
        if (this.stats) {
            // stats
            this.stats.begin();
            this.stats.end();
        }



    }

}